import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isTeachersEnabled } from 'utils/authScopes';
import ASQHeaderSort from './ASQHeaderSort';

class ASQSurveysHeader extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    onSortChange: PropTypes.func.isRequired,
  }

  // Tri-state per-column sort: 1st click on a column sorts ascending, 2nd click
  // descending, 3rd click turns sorting off (server falls back to its default order).
  onSortChange = (e) => {
    const sort = e.currentTarget.dataset.sort;
    const { meta } = this.props;

    // The server applies a default sort on the initial load, so meta.sort can match this
    // column without the provider ever having clicked it. Treat that as "not yet sorted by
    // the user" and start the cycle at ascending, otherwise the first click would land
    // mid-cycle and appear to skip a step.
    const sortedByUser = meta.sort === sort && !!meta.order && !meta.sortCleared;

    if (!sortedByUser) {
      this.props.onSortChange(sort, 'asc', false);
    } else if (meta.order === 'asc') {
      this.props.onSortChange(sort, 'desc', false);
    } else {
      // Third click clears the sort. Flag it so the server keeps the blank sort instead of
      // reapplying its default, which would make the sort impossible to turn off.
      this.props.onSortChange('', '', true);
    }
  }

  render() {
    const { t, auth, meta } = this.props;
    return (
      <div className='o-rtable__row'>
        <ASQHeaderSort meta={meta} idx={1} onSortChange={this.onSortChange}>
          <b>{t('asqSurveys.header.studentName')}</b>
        </ASQHeaderSort>
        <ASQHeaderSort meta={meta} idx={2} cls='o-rtable__cell--date' onSortChange={this.onSortChange}>
          <b>{t('asqSurveys.header.dateInvited')}</b>
        </ASQHeaderSort>
        {isTeachersEnabled(auth) && (
          <ASQHeaderSort meta={meta} idx={3} onSortChange={this.onSortChange}>
            <b>{t('asqSurveys.header.mostRecentTeacherAsq')}</b>
          </ASQHeaderSort>
        )}
        <ASQHeaderSort meta={meta} idx={4} onSortChange={this.onSortChange}>
          <b>{t('asqSurveys.header.mostRecentParentAsq')}</b>
        </ASQHeaderSort>
        {meta.followUpEnabled &&
          <ASQHeaderSort meta={meta} idx={5} onSortChange={this.onSortChange}>
            <b>{t('asqSurveys.header.followUp')}</b>
          </ASQHeaderSort>
        }
      </div>
    );
  }
}

export default withTranslation()(ASQSurveysHeader);
